import "@mantine/core/styles.css"
import "@civala/shared-ui/styles/pitch-global.css"
import "./investor.css"

import { createQueryClient } from "@civala/shared-ui/query"
import { pitchTheme } from "@civala/shared-ui/themes/pitch"
import { MantineProvider } from "@mantine/core"
import { QueryClientProvider } from "@tanstack/react-query"
import { createRouter, RouterProvider } from "@tanstack/react-router"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"

import { routeTree } from "./routeTree.gen"

// Shared client config (staleTime/SWR + retry-with-backoff that skips 401 + a 401→"/"
// bounce to re-challenge Cloudflare Access). The previous inline config lived here;
// converged onto @civala/shared-ui/query so the resilience defaults stay in lockstep
// with nexus (civala-ai/civala.ai#168). investor's API client throws raw functype
// HttpError objects ({ _tag, status }), which the shared `status === 401` check matches.
const queryClient = createQueryClient({ app: "investor" })

const router = createRouter({
  routeTree,
  defaultViewTransition: true,
})

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router
  }
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <MantineProvider theme={pitchTheme} defaultColorScheme="light">
        <RouterProvider router={router} />
      </MantineProvider>
    </QueryClientProvider>
  </StrictMode>,
)
